<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
      title="时空信箱"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      <template #right>
        <van-icon name="plus" @click="clickMailboxAdd" />
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <div
      id="desc"
      v-if="vMemorialHallDetailed"
      style="display: none"
      v-html="
        vMemorialHallDetailed.MemorialHallSearchApiModel
          .DeceasedInformationApiModelList[0].LifeIntroduction
      "
    ></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div>
          <div
            class="mainbox-list van-hairline--bottom"
            v-for="(item, pindex) in dataList"
            :key="item.HallCommentMainID"
          >
            <div class="mainbox-header">
              <div class="hd">
                <van-image
                  round
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="item.MemberApiModel.HeadPic"
                />
              </div>
              <div class="bd">
                <div class="name">{{ item.MemberApiModel.NickName }}</div>
                <p class="date">
                  发布时间：{{ $moment(item.AddDateTime).format("YYYY-MM-DD") }}
                </p>
              </div>
              <div v-if="currentToken.isLogin && isSelf" class="ft">
                <van-icon @click="delMailbox(item, pindex)" name="delete" />
              </div>
            </div>
            <div class="mainbox-body">
              <div v-html="item.Content" class="text-box rich"></div>
              <div class="image-box">
                <van-row gutter="5">
                  <van-col
                    span="8"
                    v-for="(
                      clientitem, index
                    ) in item.HallCommentMainPhonePhotoList"
                    :key="clientitem.Id"
                    @click="preview(item.HallCommentMainPhonePhotoList, index)"
                  >
                    <div class="image">
                      <van-image fit="cover" :src="clientitem.PhotoPath" />
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>

            <CommentBox
              :id="item.HallCommentMainID"
              :memorialHallID="item.MemorialHallID"
              :hallCommentMainID="item.HallCommentMainID"
              :replyList.sync="item.HallCommentReplyList"
              :isPraise.sync="item.IsPraise"
              :praiseCount.sync="item.PraiseCount"
            />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <div class="mainbox-list van-hairline--bottom" v-for="item in 2" :key="item.id">
        <div class="mainbox-header">
          <div class="hd">
            <van-image
              round
              width="100%"
              height="100%"
              fit="cover"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </div>
          <div class="bd">
            <div class="name">张三</div>
            <p class="date">发布时间：2020-04-01</p>
          </div>
          <div class="ft">
            <van-icon name="delete" />
          </div>
        </div>
        <div class="mainbox-body">
          <div class="text-box">哈利·波特》系列发布多张壁纸，供宅在家里的网友开视频会议用，有线上魔法课教学的感觉不？啥时候去霍格沃茨上课</div>
          <div class="image-box">
            <van-row gutter="6">
              <van-col span="8" v-for="item in 6" :key="item.id" @click="preview(item.index)">
                <div class="image"><van-image fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg" /></div>
              </van-col>
            </van-row>
          </div>
        </div>
        <CommentBox />
      </div>
    </div> -->
  </div>
</template>

<script>
import CommentBox from "@/components/CommentBox.vue";
import { ImagePreview, Toast, Dialog } from "vant";
import { mapGetters } from "vuex";
import auth from "../../../tools/auth";

export default {
  data() {
    return {
      id: 0,
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
      isSelf: false,
      vMemorialHallDetailed: null,
    };
  },
  components: {
    CommentBox,
  },
  computed: {
    ...mapGetters(["currentToken"]),
  },
  methods: {
    onClickLeft() {
      // this.$router.go(-1)
      this.$back();
    },
    clickMailboxAdd() {
      if (!this.$store.state.account.isLogin) {
        this.$router.push("/login?ReturnUrl=" + this.$route.fullPath);
      } else {
        this.$router.push("/MailboxAdd?id=" + this.id);
      }
    },
    preview(photolist, index) {
      var plist = [];
      if (photolist) {
        for (var i = 0; i < photolist.length; i++) {
          plist[i] = photolist[i].PhotoPath;
        }
      }
      ImagePreview({
        // images: [
        //   'https://img.yzcdn.cn/vant/cat.jpeg',
        //   'https://img.yzcdn.cn/vant/cat.jpeg',
        //   'https://img.yzcdn.cn/vant/cat.jpeg',
        //   'https://img.yzcdn.cn/vant/cat.jpeg',
        //   'https://img.yzcdn.cn/vant/cat.jpeg',
        //   'https://img.yzcdn.cn/vant/cat.jpeg',
        // ],
        images: plist,
        startPosition: index,
        closeable: true,
      });
    },
    init() {
      var that = this;
      that.options = {
        type: "GetMailBoxMailBoxSearchList",
        pageIndex: 1,
        id: that.id,
      };
      that.getIsSelf();
      that.getList();
    },
    getIsSelf() {
      var that = this;
      if (this.currentToken && this.currentToken.isLogin) {
        this.$store
          .dispatch({
            type: "getIsSelfMemorialHall",
            id: that.id,
            Mid: "",
          })
          .then(
            (res) => {
              that.isSelf = res == true;
            },
            (err) => {}
          );
      }
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1,
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1,
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.HallCommentMainApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }
          if (dataList.length < 10) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach((element) => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = dataList;
          }
        },
        (error) => {}
      );
    },
    delMailbox(item, pindex) {
      var that = this;
      Dialog.confirm({ message: "是否删除此留言" })
        .then(() => {
          that.$store
            .dispatch({
              type: "getMailBoxMailBoxDelVue",
              Id: item.HallCommentMainID,
            })
            .then(
              (res) => {
                if (res.IsSuccess) {
                  Toast(res.Message);
                  that.dataList.splice(pindex, 1);
                  // that.onRefresh();
                }
              },
              (err) => {}
            );
        })
        .catch(() => {});
    },
    initShare(id) {
      var that = this;
      var options = {
        type: "GetMemorialHallSearchApiById",
        id: id,
      };
      that.$store.dispatch(options).then((res) => {
        // console.log(res);
        that.vMemorialHallDetailed = res;
        if (res.MemorialHallSearchApiModel) {
          that.$store.commit(
            "setmid",
            res.MemorialHallSearchApiModel.SerialNumber
          );
          that.$store.commit(
            "setmuid",
            res.MemorialHallSearchApiModel.MemorialHallID
          );
        }
        if (that.$weixin.IsWeiXin()) {
          that.initweixinShare();
        }
      });
    },
    initweixinShare() {
      var that = this;
      this.$nextTick(() => {
        let desc = document.querySelector("#desc").innerText;
        if (!desc) {
          desc = that.vMemorialHallDetailed.MemorialHallSearchApiModel.Title;
        }
        that.$weixin.ShareWeiXinAppMessage(
          that.vMemorialHallDetailed.MemorialHallSearchApiModel.Title,
          desc,
          that.vMemorialHallDetailed.MemorialHallSearchApiModel
            .DeceasedInformationApiModelList[0].HeadPhoto,
          "MemorialHall?id=" + that.id
        );
      });
    },
    getMemorialHall(id){
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemorialHallSearchApiById",
          id: id
        })
        .then((res) => {
            var memorialHallapiModel = res.MemorialHallSearchApiModel;
            if (memorialHallapiModel.IsPrivacy) {
              var _id = memorialHallapiModel.SerialNumber;
              auth.IsFriend(this, _id);
            }
          },
          (err) => {}
        );
    }
  },
  activated() {
    var that = this;
    this.id = this.$route.query.id;
    this.getMemorialHall(this.id);
    this.initShare(this.id);
    that.init();
  },
  created() {
    // var that = this;
    // this.id = this.$route.query.id;
    // that.init();
  },
};
</script>

<style scoped>
</style>
